import queryString from 'query-string';

import { openFailedAlert } from 'actions/alert';

import authStorage from 'util/authStorage';
import { languageMapRoute, getLanguage } from 'util/i18n';

export const HOST_MAP = {
	dev: 'http://localhost:9000',
	demo: 'https://9floorco-living.25demo.com',
	production: 'https://9floor.co',
};

const SELF_HOST_MAP = {
	dev: 'http://localhost:3000',
	demo: 'https://9floorco-living.25demo.com',
	production: 'https://9floor.co',
};

export const API_ENDPOINT = HOST_MAP[process.env.API];
export const SELF_HOST_ENDPOINT = SELF_HOST_MAP[process.env.API];

export const generateUrl = (url, params) => {
	const paramsString = queryString.stringify(params, { arrayFormat: 'bracket' });

	const lan = getLanguage();

	const URL =
		paramsString !== ''
			? `${API_ENDPOINT}/backend/api/web/${languageMapRoute(lan)}/${url}?${paramsString}`
			: `${API_ENDPOINT}/backend/api/web/${languageMapRoute(lan)}/${url}`;

	return URL;
};

export const wrapFetch = async (url, options = { headers: {} }, params = {}) => {
	const URL = generateUrl(url, params);

	const headers = new Headers({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options.headers,
	});

	const result = await fetch(URL, { ...options, headers });

	return result.json();
};

export const wrapFetchFormData = async (url, options, params = {}) => {
	const tokenData = authStorage.getToken();
	const tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: '',
	};

	const token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

	if (token.accessToken === '') {
		throw openFailedAlert('generic', 'No Token Exist');
	}

	const URL = generateUrl(url, params);

	const result = await fetch(URL, {
		...options,
		headers: {
			Authorization: `Bearer ${token.accessToken}`,
			...options.headers,
		},
	});

	return result.json();
};

export const wrapFetchAuth = (url, options = { headers: {} }, params = {}) => {
	const tokenData = authStorage.getToken();
	const tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: '',
	};

	const token = tokenData === null ? tokenDefault : JSON.parse(tokenData);

	if (token.accessToken === '') {
		throw openFailedAlert('generic', 'No Token Exist');
	}

	return wrapFetch(
		url,
		{
			...options,
			headers: {
				Authorization: `Bearer ${token.accessToken}`,
				...options.headers,
			},
		},
		params,
	);
};



// WEBPACK FOOTER //
// ./src/actions/endpoint.js